import React, { useEffect, useState } from 'react';
import CookieConsent, { getCookieConsentValue, Cookies } from 'react-cookie-consent';
import { Link } from 'react-router-dom';

const CookieConsentBanner: React.FC = () => {
  const [hasConsent, setHasConsent] = useState<boolean>(false);
  
  // Function to load Google Analytics
  const loadGoogleAnalytics = () => {
    // Create script for Google Analytics
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-N8LL68FZVH";
    document.head.appendChild(gaScript);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any) {
      // @ts-ignore
      window.dataLayer.push(arguments);
    }
    // @ts-ignore
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-N8LL68FZVH');
    
    console.log("Google Analytics loaded");
  };

  // Check for existing consent on component mount
  useEffect(() => {
    const consentGiven = getCookieConsentValue('betterbyaiCookieConsent');
    if (consentGiven === 'true') {
      setHasConsent(true);
      loadGoogleAnalytics();
    }
  }, []);

  // Handle consent acceptance
  const handleAccept = () => {
    setHasConsent(true);
    loadGoogleAnalytics();
  };

  // Handle consent rejection
  const handleDecline = () => {
    setHasConsent(false);
    // Set a cookie to remember the user rejected tracking
    Cookies.set('betterbyaiCookieRejected', 'true', { expires: 150 });
    console.log("Analytics consent declined");
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="betterbyaiCookieConsent"
      style={{ 
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(255, 112, 102, 0.1)",
        borderRadius: "1rem",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        margin: "1rem",
        maxWidth: "calc(100% - 2rem)",
        color: "#334155",
        zIndex: 9999,
        padding: "16px 24px",
      }}
      buttonWrapperClasses="flex !justify-center items-center w-full md:justify-end md:w-auto mt-2 md:mt-0"
      buttonStyle={{ 
        background: "#FF7066",
        color: "white",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "0.5rem",
        padding: "10px 20px",
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.2s ease",
        margin: "0", // Explicitly set margin to zero
      }}
      buttonClasses="hover:bg-[#FF8A82]" // Remove ml-0 to fix offset
      expires={150}
      onAccept={handleAccept}
      enableDeclineButton
      onDecline={handleDecline}
      declineButtonText="Decline"
      declineButtonStyle={{
        background: "transparent",
        border: "1px solid #FF7066",
        color: "#FF7066",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "0.5rem",
        padding: "9px 20px",
        margin: "0 10px 0 0", // Add spacing to the right only
        cursor: "pointer",
        transition: "background-color 0.2s ease",
      }}
      declineButtonClasses="mr-2" // Consistent spacing
      containerClasses="flex flex-col items-center text-center md:text-left md:flex-row md:justify-between gap-2"
      contentClasses="mb-2 md:mb-0 md:mr-8"
      contentStyle={{ flex: '0 1 auto' }}
    >
      <span className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3">
        This website uses cookies to enhance your experience and analyse traffic. By continuing to use this site, you consent to our use of cookies.
        <span className="inline-flex items-center justify-center md:justify-start gap-3 mt-1 md:mt-0 md:ml-1">
          <Link to="/privacy" className="text-[#FF7066] underline hover:text-[#FF8A82] transition-colors">
            Privacy Policy
          </Link>
          <span className="text-gray-400">|</span>
          <Link to="/cookie-policy" className="text-[#FF7066] underline hover:text-[#FF8A82] transition-colors">
            Cookie Policy
          </Link>
        </span>
      </span>
    </CookieConsent>
  );
};

// Add this type definition for the gtag function
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export default CookieConsentBanner;